__turbopack_context__.v({
  "backButton": "ScfO4a_backButton",
  "backIcon": "ScfO4a_backIcon",
  "content": "ScfO4a_content",
  "devBanner": "ScfO4a_devBanner",
  "dialog": "ScfO4a_dialog",
  "goalCard": "ScfO4a_goalCard",
  "goalCardSelected": "ScfO4a_goalCardSelected",
  "goalHead": "ScfO4a_goalHead",
  "goalIcon": "ScfO4a_goalIcon",
  "goalPoints": "ScfO4a_goalPoints",
  "goalTitle": "ScfO4a_goalTitle",
  "goals": "ScfO4a_goals",
  "hint": "ScfO4a_hint",
  "main": "ScfO4a_main",
  "nav": "ScfO4a_nav",
  "ob-fade": "ScfO4a_ob-fade",
  "ob-reveal": "ScfO4a_ob-reveal",
  "primaryButton": "ScfO4a_primaryButton",
  "reveal": "ScfO4a_reveal",
  "scenarioCard": "ScfO4a_scenarioCard",
  "scenarioIcon": "ScfO4a_scenarioIcon",
  "scenarioRow": "ScfO4a_scenarioRow",
  "scenarios": "ScfO4a_scenarios",
  "screen": "ScfO4a_screen",
  "title": "ScfO4a_title",
});
